import { useState } from "react";
import { Award, Lock, Shirt, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { http, formatApiError } from "@/lib/api";
import { useProfile } from "@/context/ProfileContext";
import { Progress } from "@/components/ui/progress";

export const BuddyGrowth = ({ p }) => {
  const { buddy, setBuddy } = useProfile();
  const [busy, setBusy] = useState("");
  const wear = async (outfit) => {
    setBusy(outfit);
    try {
      await http.post("/buddy/teach/outfit", { outfit });
      setBuddy((await http.post("/buddy/portrait")).data.buddy);
      toast.success(`${buddy.name} loves the new outfit!`);
    } catch (e) { toast.error(formatApiError(e)); }
    setBusy("");
  };
  return (
    <section className="rounded-3xl bg-white/70 border border-[#E6DEC3] p-6" data-testid="buddy-growth">
      <div className="flex flex-wrap items-center gap-4">
        <div className="w-16 h-16 rounded-2xl bg-[#2C4A3E] text-white grid place-items-center"><div className="text-center leading-none"><div className="text-[10px] uppercase tracking-widest">Level</div><div className="font-display text-2xl" data-testid="buddy-level">{p.level}</div></div></div>
        <div className="flex-1 min-w-[180px]">
          <p className="text-sm text-stone-600">{buddy.name} grows every time you teach them</p>
          <div className="flex items-center gap-3 mt-2"><Progress value={(100 * p.xp_in_level) / p.xp_per_level} className="h-2.5" /><span className="text-xs text-stone-500 whitespace-nowrap" data-testid="buddy-xp">{p.xp_in_level}/{p.xp_per_level} XP</span></div>
        </div>
      </div>
      <div className="flex flex-wrap gap-2 mt-5" data-testid="buddy-badges">
        {p.badges.map((b) => (
          <span key={b.id} data-testid={`badge-${b.id}`} data-earned={b.earned}
            className={`inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full text-xs font-medium ${b.earned ? "bg-[#F2D49B] text-[#5B3A1E]" : "bg-[#F1EADB] text-stone-400"}`}>
            {b.earned ? <Award className="w-3.5 h-3.5" /> : <Lock className="w-3 h-3" />}{b.name}
          </span>
        ))}
      </div>
      <p className="text-xs uppercase tracking-widest text-stone-500 mt-6">Outfits</p>
      <div className="flex flex-wrap gap-2 mt-2" data-testid="buddy-outfits">
        {p.outfits.map((o, i) => (
          <button key={o.name} disabled={!o.unlocked || !!busy} onClick={() => wear(o.name)} data-testid={`outfit-${i}`} title={o.unlocked ? "Wear it" : `Unlocks at level ${o.level}`}
            className={`inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full text-xs border transition-colors ${o.unlocked ? "bg-white border-[#6B9080] text-[#2C4A3E] hover:bg-[#E3EBE5]" : "bg-[#F7F3EB] border-[#E6DEC3] text-stone-400"} ${buddy.look.style === o.name ? "ring-2 ring-[#C87D53]" : ""}`}>
            {busy === o.name ? <Loader2 className="w-3 h-3 animate-spin" /> : o.unlocked ? <Shirt className="w-3 h-3" /> : <Lock className="w-3 h-3" />}
            {o.unlocked ? o.name.replace(/^an? /, "") : `Level ${o.level}`}
          </button>
        ))}
      </div>
    </section>
  );
};
